import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import infoBlack from "../../../../static/images/blackinfo.png"

const MyTooltip = ({ checkerRemarks, fieldName, prefix = null }) => {
  // Function to retrieve the checker remark for the given fieldName
  const getCheckerRemark = (remarks, key) => {
    try {
      if (prefix) {
        key = `${prefix}${key}`;
      }
      key = key.replace(/\[/g, '.').replace(/\]/g, '')

      // Check if remarks and the specific key exist, and if the remarks property is present
      if (remarks && remarks[key] && remarks[key].remarks) {
        return remarks[key].remarks;
      }
      return null; // Return null if no remark is available
    } catch (e) {
      console.error('Error retrieving checker remark:', e);
      return null;
    }
  };

  // Retrieve the remark for the specified fieldName
  const remark = getCheckerRemark(checkerRemarks, fieldName);

  // Conditionally render the Tooltip only if a remark is available
  return (
    remark ? (
      <div className="toolTipContainer" style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
        <Tooltip
          placement="bottom"
          trigger={['hover']}
          overlay={<span>{remark}</span>}
        >
          <span className="info-icon" style={{ cursor: 'pointer', position: 'relative' }}>
            <img src={infoBlack} style={{width: '12px'}}/>
          </span>
        </Tooltip>
      </div>
    ) : null // Render nothing if no remark is available
  );
};

export default MyTooltip;
